<template>
<div class="page" id="product">
  <carousel :autoplay="true" perPage="1" autoplayHoverPause="true" loop="false" speed="800" autoplayTimeout='3000'>
    <slide>
      <div class='service_content'>
          <div class="half desc">

              <h3 class="serv_slide" style="line-height:3vw;"><b>INO</b> Magazine</h3>
              <div id="pass">
                  <p class="serv-pass" style="font-weight:300; font-size:1.1rem;">JANCARUS will publish electronic magazine four times per year: summer, spring, fall, winter editions highlighting various
topics, such as learning, wellness, technology. The magazine will be available to our email subscribers. We will offer opportunities to win prizes and writing
opportunities to tell your story/narrative for publication in the INO magazine. The fall issue is available online.</p>
                      <router-link class="button" v-bind:to="'/products/inomagazine'">Read Now</router-link>
              </div>
          </div>
          <div class="half img">
              <img class="ino" style='height:500px; width:300px;' src='@/assets/ino_2018_autumn.jpg' /></div>
      </div>

    </slide>
    <slide>
      <h3 class="serv_slide">D.E.A.L.S Game</h3>
      <div class="covergame">
      <img src='@/assets/3dgame.jpg'/></div>      <a href="https://jancarus.org" class="button">Play Now</a>

    </slide>
    <slide>
      <h3 class="serv_slide">30by30</h3>
      <p>Coming Soon!</p>
 <a  class="button">Learn More</a>    </slide>
    <slide>
      <h3 class="serv_slide">Apparel</h3>
      <p>Coming Soon!</p>
 <a class="button">Buy Now</a>    </slide>
  </carousel>
</div>
</template>

<script>
export default {
  name: 'about'
}
</script>
<!-- styling for the component -->
<style scoped>
li {
  list-style: none;
}
.prod_title{
  font-weight:700;
}
img{
  box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);

}
.ino{
  border: 25px solid #708090;

}
#product {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size:1.4rem;
  margin-top: 10px;
  font-weight:300;
  height: 100%;
}
.mag_cover{
  width:300px;
  position:relative;
  height:500px;

}
.covergame img{
  width:60% !important;
  height:auto;
}
.button{
  background: #ff6100;
  padding: 10px;
  letter-spacing: 0 !important;
  position: relative;
  font-size: 1rem !important;
  text-decoration: none;
  transition: 5s;
  brder:none;
  cursor:pointer;
  border-radius: 40px;
  overflow: hidden;
  transform: translate(0%, 0%);
  top: 12px;
  color:#fff;
}
.button:before {
  background: rgba(252, 2, 2, 0);
  content: "";
  filter: blur(4px);
  transition: 5s;
  border-radius: 50%;
  position: absolute;
  height: 40px;
  width: 40px;
  z-index: -1;
  left: 0;
}

.button:after {
  background: rgba(255, 246, 12, 0);
  content: "";
  filter: blur(4px);
  transition: 5s;
  border-radius: 50%;
  position: absolute;
  height: 40px;
  width: 40px;
  z-index: -1;
  right: 0;
  top: 0;
}

.button:hover {
  color: #000 !important;
  text-shadow: 0 5px 15px #fff;
  box-shadow: -15px 0 30px rgba(226, 182, 63, 1);
}

.button:hover:before {
  background: rgba(252, 2, 2, 1);
  transform: scaleX(5);
}

.menu-started:hover:after {
  background: rgba(255, 246, 12, 1);
  transform: scaleX(5);
}
.VueCarousel-wrapper{
  overflow:visible;
}
.serv_slide {
  font-size: 3vw;
  line-height: 5rem;
  letter-spacing: 2vw;
  text-transform: uppercase;
  margin-left: 0px;
  text-align:center;
  font-weight:400;
}
.service_content{
  display:inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Products.vue